import { useState } from "react";
import { useTranslation } from "react-i18next";

const MAGIC_ITEM_TYPE = "magic";

const SpellcastingItems = ({ items = [], onChange }) => {
  const { t } = useTranslation();
  const [isPickerOpen, setIsPickerOpen] = useState(false);
  const availableItems = items.filter((item) => item.type === MAGIC_ITEM_TYPE);
  const selectedItems = availableItems.filter((item) => item.isSpellcastingActive);

  const setSelected = (itemId, isSpellcastingActive) => {
    onChange(items.map((item) => item.id === itemId ? { ...item, isSpellcastingActive } : item));
    if (isSpellcastingActive) setIsPickerOpen(false);
  };

  return (
    <section className="spellcasting-items">
      <div className="spellcasting-items-header">
        <h2>{t("spells.magicItems")}</h2>
        <button aria-label={t("spells.addMagicItem")} className="add-skill-button" type="button" onClick={() => setIsPickerOpen((current) => !current)}>+</button>
      </div>
      <div className="spellcasting-items-list">
        {selectedItems.map((item) => (
          <div className="spellcasting-item" key={item.id}>
            <div>
              <strong>{item.name}</strong>
              <small>{t("spells.magic")}</small>
              {item.notes && <p>{item.notes}</p>}
            </div>
            <button aria-label={t("spells.removeMagicItem", { name: item.name })} className="inventory-delete-button" type="button" onClick={() => setSelected(item.id, false)}>&times;</button>
          </div>
        ))}
        {selectedItems.length === 0 && <p className="spellcasting-items-empty">{t("spells.noMagicItemsSelected")}</p>}
      </div>
      {isPickerOpen && (
        <div className="spellcasting-items-picker">
          <strong>{t("spells.addFromInventory")}</strong>
          {availableItems.map((item) => (
            <button aria-label={t("spells.addMagicItemNamed", { name: item.name })} className={item.isSpellcastingActive ? "selected" : ""} disabled={item.isSpellcastingActive} key={item.id} type="button" onClick={() => setSelected(item.id, true)}>
              <span className="spellcasting-picker-item-info">
                <span>{item.name}</span>
                {item.notes && <small>{item.notes}</small>}
              </span>
              <small>{t("spells.magic")}</small>
            </button>
          ))}
          {availableItems.length === 0 && <small>{t("spells.noMagicItemsInventory")}</small>}
        </div>
      )}
    </section>
  );
};

export default SpellcastingItems;
